import { useState, useEffect, useRef } from 'react';
import { useScroll, useTransform } from 'framer-motion';
import CustomCursor from './components/CustomCursor';
import GrainOverlay from './components/GrainOverlay';
import HeroSection from './components/sections/HeroSection';
import ProblemSection from './components/sections/ProblemSection';
import ProductSection from './components/sections/ProductSection';
import FeaturesSection from './components/sections/FeaturesSection';
import FooterSection from './components/sections/FooterSection';
import './styles/global.css';

const App = () => {
  const [heroComplete, setHeroComplete] = useState(false);
  const [showSubtext, setShowSubtext] = useState(false);
  const problemRef = useRef(null);
  const productRef = useRef(null);
  const [problemRevealed, setProblemRevealed] = useState(false);
  const [showSilent, setShowSilent] = useState(false);

  const { scrollYProgress: productScroll } = useScroll({
    target: productRef,
    offset: ['start end', 'end start'],
  });
  const cardSpread = useTransform(productScroll, [0.2, 0.5], [0, 1]);

  const { scrollYProgress: problemScroll } = useScroll({
    target: problemRef,
    offset: ['start end', 'end start'],
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setProblemRevealed(true);
        }
      },
      { threshold: 0.5 }
    );
    if (problemRef.current) observer.observe(problemRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (heroComplete) setTimeout(() => setShowSubtext(true), 300);
  }, [heroComplete]);

  return (
    <div style={{ minHeight: '100vh', color: '#F2F2F2', background: '#050505' }}>
      <GrainOverlay />
      <CustomCursor />

      <HeroSection
        heroComplete={heroComplete}
        setHeroComplete={setHeroComplete}
        showSubtext={showSubtext}
      />

      <ProblemSection
        problemRef={problemRef}
        problemRevealed={problemRevealed}
        problemScroll={problemScroll}
      />

      <ProductSection productRef={productRef} cardSpread={cardSpread} />

      <FeaturesSection />

      <FooterSection />
    </div>
  );
};

export default App;
